import { shallowEqual } from 'react-redux';

import {
  getPhoneCallAvailability,
  type PhoneCallAvailabilityOptions,
  type PhoneCallAvailabilityResult,
} from 'components/telephony/utils/phoneCallAvailability';
import { useAppSelector } from 'utils/redux/useAppSelector';

export function usePhoneCallAvailability(
  options: PhoneCallAvailabilityOptions = {},
): PhoneCallAvailabilityResult {
  // shallowEqual: `getPhoneCallAvailability` returns a new object literal on
  // every call, so without a custom equality fn the default identity check in
  // useSelector would re-render every consumer on every Redux dispatch (e.g.
  // each presence tick). Shallow-comparing the flattened fields means we only
  // re-render when an availability flag, the tooltip text, or the selected
  // from-number reference actually changed.
  return useAppSelector(
    (state) => getPhoneCallAvailability(state, options),
    shallowEqual,
  );
}
